import { Observable } from 'rxjs';
import {
  buildFirestoreDocument,
  createDoc,
  getCollectionDocs,
  getDocOrThrow,
  QueryCollectionOptions,
} from '../utils/firestore.utils';
import { FirestoreDocument } from '../../shared/models/firestore-document';
import { OrganizationUser } from '../../models/organization/organization-user.model';
import { getOrganizationRef, getOrganizationsCol, getOrganizationUsersCol } from '../refs/organization.refs';
import { DocumentReference, Firestore } from '@angular/fire/firestore';
import { Organization } from '../../models/organization/organization.model';

//
// Organization
//
export async function createOrganization(
  firestore: Firestore,
  data: Organization
): Promise<FirestoreDocument<Organization>> {
  const col = getOrganizationsCol(firestore);
  const ref = await createDoc(col, data);
  return buildFirestoreDocument(ref, data);
}

export function getOrganization(
  firestore: Firestore,
  organizationId: string
): Observable<FirestoreDocument<Organization>> {
  const ref = getOrganizationRef(firestore, organizationId);
  return getDocOrThrow(ref);
}

export function getOrganizations<K extends keyof Organization>(
  firestore: Firestore,
  options?: QueryCollectionOptions<Organization, K>
): Observable<FirestoreDocument<Organization>[]> {
  const col = getOrganizationsCol(firestore);
  return getCollectionDocs(col, options);
}

//
// OrganizationUser
//
export function getOrganizationUsers<K extends keyof OrganizationUser>(
  parentRef: DocumentReference<Organization>,
  options?: QueryCollectionOptions<OrganizationUser, K>
): Observable<FirestoreDocument<OrganizationUser>[]> {
  const col = getOrganizationUsersCol(parentRef);
  return getCollectionDocs(col, options);
}
